import React from 'react';

// import { Container } from './styles';

function ProductionOrders() {
  return (
    <div>
      <p>Production orders Screen</p>
    </div>
  );
}

export default ProductionOrders;